module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "banner-header"
  }, [_c('div', {
    staticClass: "banner-left"
  }, [_c('img', {
    attrs: {
      "src": _vm.img
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.closeCss,
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "banner-right",
    on: {
      "click": function($event) {
        _vm.public.downloadApp(_vm.type)
      }
    }
  }, [_c('button', [_vm._v("\n      立即下载\n    ")])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("打开一起买买买APP")]), _vm._v(" "), _c('div', {
    staticClass: "title-footer"
  }, [_vm._v("每人送积分可免单")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f086b80c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/taoke/TotalHeader.vue
// module id = 219
// module chunks = 2